// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".b0f41671b32fb9ee64f5fb6af7efc84d.js";
};